import { useCommentableTextAtoms, useCommentsDrawer, useCommentsList } from '@/comments';
import { CommentableModel } from '@/enums';
import { CommentsMenu } from './CommentsMenu';

interface Props {
    open: boolean;
    drawerPosition?: 'static';
    onClose?: () => void;
    narrow?: boolean;
}

export const CommentsDrawer = ({ open, drawerPosition, onClose, narrow: _narrow }: Props) => {
    const [drawer, drawerActions] = useCommentsDrawer();
    const { textAtomIds } = useCommentableTextAtoms();

    const { comments } = useCommentsList({
        commentableIds: textAtomIds,
        commentableModel: CommentableModel.text_atom,
        enabled: open,
    });

    const handleClose = () => {
        drawerActions.close();
        onClose?.();
    };

    return (
        <CommentsMenu
            showTopInput={drawer.showTopInput}
            commentableId={drawer.commentableId || 0}
            commentableModel={drawer.commentableModel || ''}
            position={drawer.position || ''}
            openId={drawer.focusedCommentId}
            open={open}
            filterName={drawer.filterName}
            textAtomContent={drawer.textAtomContent}
            comments={comments}
            onClose={handleClose}
            selectionIndex={drawer.selectionIndex}
            drawerPosition={drawerPosition}
        />
    );
};
